<template>
  <div>
    <div class="list" v-if="orderList.length>0">
      <div
        v-for="(item,index) in orderList"
        :key="index"
        class="item"
        @click="toDetail(item.id)"
      >
		<div style="flex:1;">
			<div>报告编号：{{ item.order_id }}</div>
			<div>日期时间：{{ item.date }}</div>
			<div>日期类型：{{ item.calendar==0?'阴历':'阳历' }}</div>
			<div>测 算 人 ：{{ item.username || "" }}</div>
			<div>处理性别：{{ item.gender }}</div>
			<div>
				支付金额：{{ item.pay_price > 0 ? item.pay_price : "会员卡测算" }}
			</div>
			<div>订单时间：{{ item.add_time }}</div>
		</div>
		<div style=" padding: 0 7px; background: #69503C; border-radius: 10px; color:#FFF; height: 30px; line-height: 30px; font-size: 12px; text-align: center;align-self: flex-end;">
			查看详情
		</div>
      </div>
    </div>
    <div v-else style="padding: 1rem; text-align: center">
      <div>暂无辨证报告</div>
    </div>
	<div style="height: 1.2rem;"></div>
  </div>
</template>

<script>
	import { getSizhuOrderList } from "@api/order";
export default {
    data: function () {
    return {

		page: 1,
		limit: 20,
		loaded: false,
		loading: false,
		orderList: [],
    };
  },
  created() {
		this.$router.push('/');
		this.getOrderList();
  },
  mounted: function () {},
  methods: {
    toDetail(id){
		this.$router.push({
            path: "/sizhu/result/" + id
        });
    },
	
	getOrderList() {
	  if (this.loading || this.loaded) return;
	  this.loading = true;
	  const { page, limit, type } = this;
	  getSizhuOrderList({
	    page,
	    limit,
	    type
	  }).then(res => {
	    this.orderList = this.orderList.concat(res.data);
	    this.page++;
	    this.loaded = res.data.length < this.limit;
	    this.loading = false;
	  });
	},
  },
};
</script>

<style scoped>
.list {
	padding-bottom: 0.2rem;
}

.item {
	margin: 0.2rem 0.2rem 0;
	background: #fff;
	border-radius: 0.1rem;
	padding: 0.2rem;
	display: flex;
	
}

</style>